import { EnhancedStore } from "@reduxjs/toolkit";
import { setKeys, setAuthorization} from "../store/reducers/authorizationSlice";
import { RESET_ACTION } from "../store";

const authorizeUser = (store: EnhancedStore, cloud: string) => {
  if (cloud) {
    // validation code goes here
    const isAuthorized = (cloud === '123');
    store.dispatch(setAuthorization(isAuthorized));
    
    if (isAuthorized) {
      store.dispatch(setKeys({cloudKey: cloud}));
    }
  }
  
  return false;
};

const logoutUser = (store: EnhancedStore) => {
  store.dispatch(setKeys({cloudKey: ''}));
  store.dispatch(setAuthorization(false));
  store.dispatch(RESET_ACTION);
};

export { authorizeUser, logoutUser };

